import React from 'react';

/**
 * MentorzaLogo – Official Mentorza 3-Bar Brand Logo Component
 *
 * Variants:
 *  - "mark"       → Icon mark only (3 coloured bars).
 *  - "horizontal" → Icon mark + "mentorza" text side-by-side.
 *  - "stacked"    → Icon mark on top, text below.
 */

export function MarkSvg({ size = 32 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      style={{ display: 'block' }}
    >
      {/* Navy blue bar – left, tilted */}
      <rect x="28" y="52" width="44" height="132" rx="6" fill="#1d3c6e" transform="rotate(-8 50 118)" />
      {/* Green bar – center, straight */}
      <rect x="82" y="44" width="44" height="140" rx="6" fill="#2d6b42" />
      {/* Cyan bar – right, slightly elevated */}
      <rect x="136" y="20" width="44" height="148" rx="6" fill="#14aedc" transform="rotate(3 158 94)" />
    </svg>
  );
}

export function HorizontalSvg({ height = 28, textColor = '#ffffff' }) {
  const width = Math.round((560 / 200) * height);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 560 200"
      width={width}
      height={height}
      aria-label="mentorza"
      focusable="false"
      style={{ display: 'block' }}
    >
      {/* 3 Bars Mark */}
      <rect x="28" y="52" width="44" height="132" rx="6" fill="#1d3c6e" transform="rotate(-8 50 118)" />
      <rect x="82" y="44" width="44" height="140" rx="6" fill="#2d6b42" />
      <rect x="136" y="20" width="44" height="148" rx="6" fill="#14aedc" transform="rotate(3 158 94)" />
      {/* Wordmark */}
      <text
        x="215"
        y="135"
        fontFamily="'Plus Jakarta Sans', 'Inter', -apple-system, sans-serif"
        fontSize="80"
        fontWeight="600"
        letterSpacing="-1.5"
        fill={textColor}
      >
        mentorza
      </text>
    </svg>
  );
}

export default function MentorzaLogo({ variant = 'horizontal', height = 28, textColor = '#ffffff', className = '' }) {
  if (variant === 'mark') {
    return (
      <span className={`inline-flex shrink-0 items-center justify-center ${className}`} style={{ height, width: height, display: 'inline-flex' }}>
        <MarkSvg size={height} />
      </span>
    );
  }

  if (variant === 'stacked') {
    return (
      <div className={`inline-flex flex-col items-center gap-1 ${className}`} style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
        <MarkSvg size={height} />
        <span style={{ fontSize: Math.round(height * 0.42), color: textColor, fontWeight: 700, letterSpacing: '-0.02em', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
          mentorza
        </span>
      </div>
    );
  }

  return (
    <span className={`inline-flex items-center ${className}`} style={{ display: 'inline-flex', alignItems: 'center' }}>
      <HorizontalSvg height={height} textColor={textColor} />
    </span>
  );
}
